import * as types from '../actions/actionTypes';

export default function (state = {}, { type, ...payload }) {
    switch (type) {
        case types.RESET_PRE_REG_PATIENT:
            return {};
        case types.ADD_PRE_REG_PATIENT:
            return {
                ...payload
            };
        case types.FETCH_PRE_REG_PATIENT:
            return {
                ...payload
            };
        default:
            return state;
    }
}